export function getAsset3DModelImageURL(
  type: string,
  geckoAssetsUrl: string
): string | undefined {
  switch (type) {
    case 'vertical_tank':
      return `${geckoAssetsUrl}/rich_asset_model/tank.png`
    case 'horizontal_tank':
      return `${geckoAssetsUrl}/rich_asset_model/pressure vessel.png`
    case 'piping':
      return `${geckoAssetsUrl}/rich_asset_model/pipeline.png`
    case 'legacy_boiler':
      return `${geckoAssetsUrl}/rich_asset_model/boiler.png`
    case 'ship':
      return `${geckoAssetsUrl}/rich_asset_model/boat.png`
    case 'machined_forging':
      return `${geckoAssetsUrl}/rich_asset_model/machined forging.png`
  }
  return undefined
}
